import React, { Component } from "react";
import { Button, Cascader, Select } from "antd";
import SearchRetrieve from "../../common/SearchRetrieve.new";
import API_URL from "../../../common/url";
import UploadFile from "../../common/UploadFile";

const Option = Select.Option;

class Filter extends Component {

    state = {
        searchParams: {},
    }

    handleChange = (value, key) => {
        const { searchParams } = this.state;
        searchParams[key] = value;
        this.setState({ searchParams });
    }

    handleSearchRetrieveChange = (options, key) => {
        const { searchParams } = this.state;
        searchParams[`${key}Id`] = options.value;
        searchParams[`${key}Name`] = options.text;
        this.setState({ searchParams });
    }

    render() {
        const {
            search,
            exportData,
            downTemplate,
            onUplodChange,
            update,
            businessList,
            researchProductTypeList
        } = this.props;
        const { searchParams } = this.state;
        const {
            lineOfBusinessId,
            researchProductTypeId,
            diseaseName,
            investigationAreaName,
        } = searchParams;
        const businessOption = businessList.filter(el => el.groupId == 1).map(el => <Option value={el.typeConfigureId}>{el.typeValue}</Option>);  //业务线
        return (
            <div className="search-bar" style={{ marginBottom: 10 }}>
                <div className="search-item">
                    <label htmlFor="" className="ui-label">业务线</label>
                    <Select
                        style={{ width: 120 }}
                        allowClear
                        placeholder='请选择'
                        value={lineOfBusinessId}
                        onChange={value => this.handleChange(value, 'lineOfBusinessId')}
                    >
                        {businessOption}
                    </Select>
                </div>
                <div className="search-item">
                    <label htmlFor="" className="ui-label">研究产品类型</label>
                    <Cascader
                        style={{ width: 120 }}
                        allowClear
                        placeholder="请选择"
                        options={researchProductTypeList}
                        value={researchProductTypeId}
                        onChange={value => this.handleChange(value, 'researchProductTypeId')}
                    />
                </div>
                <div className="search-item">
                    <label htmlFor="" className="ui-label">项目领域</label>
                    <SearchRetrieve
                        keyword='investigationAreaName'
                        style={{ width: 160 }}
                        placeholder="输入名称检索"
                        value={investigationAreaName}
                        params={{ limit: 20 }}
                        url={API_URL.evaluate.queryInvestigationAreaListNoPage}
                        config={{ id: 'investigationAreaId', name: 'investigationAreaName' }}
                        onChange={options => this.handleSearchRetrieveChange(options, 'investigationArea')}
                    />
                </div>
                <div className="search-item">
                    <label htmlFor="" className="ui-label">疾病</label>
                    <SearchRetrieve
                        keyword='keyword'
                        style={{ width: 160 }}
                        placeholder='键入疾病名称自动检索'
                        params={{ limit: 20 }}
                        url={API_URL.common.queryAllDisease}
                        config={{ id: 'diseaseId', name: 'diseaseName' }}
                        value={diseaseName}
                        onChange={options => this.handleSearchRetrieveChange(options, 'disease')}
                    />
                </div>
                <div className="search-item">
                    <Button key='search' type="primary" onClick={() => search(searchParams)}>搜索</Button>
                    <Button key='export' type="primary" onClick={exportData}>导出</Button>
                    <Button key='download' type="primary" style={{backgroundColor:'#ff9933', border:'0'}} onClick={downTemplate}>下载模板</Button>
                    <UploadFile
                        uploadUrl={API_URL.evaluate.importEvaluateVisitHour}
                        showUploadList={false}
                        onChange={onUplodChange}
                    >
                        <Button type="primary" className='yellow-btn'>导入数据</Button>
                    </UploadFile>
                    <Button key='add' type="primary" onClick={() => update({}, 'add')}>添加</Button>
                </div>
            </div>
        )
    }
}

export default Filter



// WEBPACK FOOTER //
// ./src/components/clinicalEvaluation/visitingHours/Filter.js